import React, { useContext, useEffect, useState, useRef, useCallback } from 'react';
import {
  AppBar,
  Avatar,
  Box,
  IconButton,
  Toolbar,
  Typography,
  Paper,
  TextField,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
} from '@mui/material';
import { Send, ArrowBack, MoreVert } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from './../../AuthContext/AuthContext';
import FormsBottomNavbar from './../Post Module/FormsBottomNavbar';
import { BASE_URL, Notification_Url } from './../../Api/ApiUrls';

const ChatWindow = () => {
  const { userId, userName } = useContext(AuthContext);
  console.log('User ID from context:', userId);
  const location = useLocation();
  const propertyId = location.state?.property;
  const navigate = useNavigate();

  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [receiverId, setReceiverId] = useState(null);
  const [propertyDetails, setPropertyDetails] = useState(null);
  const [propertyCategory, setPropertyCategory] = useState(null);
  const messagesEndRef = useRef(null);
const fetchChat = useCallback(async () => {
  if (!propertyId || !userId) return;

  const parsedUserId = parseInt(userId, 10);
  const parsedPropertyId = parseInt(propertyId, 10);

  try {
    const propertyRes = await axios.get(`${BASE_URL}/property/${parsedPropertyId}/`);
    const propertyData = propertyRes.data;
    const propertyOwnerId = parseInt(propertyData?.user_id, 10);
    setPropertyDetails(propertyData);
    console.log('Property owner:', propertyOwnerId);

    const res = await axios.get(`${BASE_URL}/chat-messages/?property_id=${parsedPropertyId}`);
    const allMessages = res.data;
    console.log('All messages:', allMessages);

    // Only include messages involving current user
    const userInvolvedMessages = allMessages.filter(
      msg => parseInt(msg.user_id, 10) === parsedUserId || parseInt(msg.receiver, 10) === parsedUserId
    );
    console.log('User involved messages:', userInvolvedMessages);

    // Determine the other user in the conversation
    let otherUserId = null;
    const sampleMsg = userInvolvedMessages.find(
      msg => parseInt(msg.user_id, 10) !== parsedUserId || parseInt(msg.receiver, 10) !== parsedUserId
    );
    if (sampleMsg) {
      otherUserId =
        parseInt(sampleMsg.user_id, 10) === parsedUserId
          ? parseInt(sampleMsg.receiver, 10)
          : parseInt(sampleMsg.user_id, 10);
    } else if (propertyOwnerId !== parsedUserId) {
      otherUserId = propertyOwnerId;
    }
    setReceiverId(otherUserId);
    console.log('Derived other user:', otherUserId);

    // Filter only messages between userId <-> otherUserId and same property
    const finalMessages = allMessages.filter((msg) => {
      const msgUserId = parseInt(msg.user_id, 10);
      const msgReceiver = parseInt(msg.receiver, 10);
      const msgPropertyId = parseInt(msg.property_id, 10);

      return (
        msgPropertyId === parsedPropertyId &&
        (
          (msgUserId === parsedUserId && msgReceiver === propertyOwnerId) ||
          (msgUserId === propertyOwnerId && msgReceiver === parsedUserId)
        )
      );
    });

    console.log('Filtered messages:', finalMessages);
    setMessages(finalMessages);

    setTimeout(() => {
      messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  } catch (error) {
    console.error('Error in fetchChat:', error);
  }
}, [propertyId, userId]);






  const fetchPropertyDetails = useCallback(async () => {
    try {
      const response = await axios.get(`${BASE_URL}/property/${propertyId}/`);
      setPropertyDetails(response.data);
      
      // Fetch category details if category_id exists
      if (response.data.category_id) {
        const categoryResponse = await axios.get(`${BASE_URL}/property-category/`);
        const category = categoryResponse.data.find(
          cat => cat.category_id === response.data.category_id
        );
        setPropertyCategory(category);
      }
    } catch (err) {
      console.error('Failed to fetch property details:', err);
    }
  }, [propertyId]);

useEffect(() => {
  if (propertyId && userId) {
    fetchChat();
    fetchPropertyDetails();
    const interval = setInterval(fetchChat, 5000);
    return () => clearInterval(interval);
  }
}, [fetchChat, fetchPropertyDetails, propertyId, userId]);


  const handleSend = async () => {
    if (!newMessage.trim() || !receiverId || !propertyId) {
      console.error('Cannot send - missing required fields');
      return;
    }

    try {
      const messageRes = await axios.post(`${BASE_URL}/chat-messages/`, {
        user_id: userId,
        receiver: propertyDetails.user_id,
        message: newMessage,
        property_id: propertyId,
      });

      console.log('Message sent:', messageRes.data);
      setNewMessage('');
      fetchChat();

      const userRes = await axios.get(`${BASE_URL}/users/${receiverId}/`);
      const receiverData = userRes.data;
      const fcmToken = receiverData.fcm_token;
      const receiverUsername = userId;
      const receiverName = receiverData.username;

      if (fcmToken) {
        const notificationRes = await axios.post(`${Notification_Url}/send-notification`, {
          token: fcmToken,
          title: `Message from ${receiverName}`,
          body: newMessage,
          id: receiverUsername,
        });

        console.log('Notification sent:', notificationRes.data);
      } else {
        console.warn('No FCM token found for receiver');
      }
    } catch (error) {
      console.error('Failed to send message or notification:', error);
    }
  };

 const handlePropertyClick = () => {
  if (propertyDetails) {
    let route = propertyDetails.user_id === 1 
      ? '/new-description' 
      : propertyDetails.type === 'sell' ? '/Buy-description'
      : propertyDetails.type === 'best-deal' ? '/hot-property-description'
      : propertyDetails.type === 'rent' ? '/rent-description'
      : propertyDetails.type === 'lease' ? '/lease-description'
      : '/new-description';

    navigate(route, {
      state: {
        propertyId: propertyId,
        property: propertyDetails
      }
    });
  }
};

  const formatTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const formatPriceINR = (price) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(price);
  };

  if (!propertyId) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="h6">No property selected</Typography>
        <Typography variant="body1">Please go back and select a property to view its chat</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 800,
        mx: 'auto',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#e5ddd5',
        backgroundImage: 'url("https://web.whatsapp.com/img/bg-chat-tile-light_a4be512e7195b6b733d9110b408f075d.png")',
      }}
    >
      {/* App Bar */}
      <AppBar position="sticky" elevation={0} sx={{ bgcolor: '#075e54', color: 'white' }}>
        <Toolbar sx={{ bgcolor: 'black', color: 'white' }}>
          <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
            <ArrowBack />
          </IconButton>
          <ListItemText
            primary={propertyDetails?.property_name || `Property #${propertyId}`}
            sx={{ color: 'white', ml: 1 }}
            primaryTypographyProps={{ fontWeight: 'bold' }}
            secondaryTypographyProps={{ fontSize: '0.75rem' }}
          />
          <IconButton edge="end" color="inherit">
            <MoreVert />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Property Info Row */}
      {propertyDetails && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 2,
            py: 1,
            bgcolor: '#f5f5f5',
            borderBottom: '1px solid #ccc',
            cursor: 'pointer',
          }}
          onClick={handlePropertyClick}
        >
         <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', overflow: 'hidden' }}>
  {propertyCategory && (
    <Typography 
      variant="body2" 
      fontWeight="bold" 
      color="text.secondary"
      sx={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
          textDecoration: 'underline',
        }
      }}
    >
      {propertyCategory.category} - {propertyDetails.property_name}
    </Typography>
  )}
  <Typography 
    sx={{ 
      fontWeight: 500,
      whiteSpace: 'nowrap',
      ml: 1 // Add some margin between the texts
    }}
  >
    {formatPriceINR(propertyDetails.price)}
  </Typography>
</Box>
        </Box>
      )}
      {/* Messages */}
      <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 2, display: 'flex', flexDirection: 'column' }}>
        <List sx={{ width: '100%' }}>
          {messages.map((msg, idx) => (
            <ListItem
              key={idx}
              sx={{
                justifyContent: msg.user_id == userId ? 'flex-end' : 'flex-start',
                px: 0,
                py: 0.5,
              }}
            >
              {msg.user_id !== userId && (
                <ListItemAvatar>
                  <Avatar src={`https://i.pravatar.cc/150?u=${msg.user_id}`} />
                </ListItemAvatar>
              )}
              <Box sx={{ display: 'flex', flexDirection: 'column', maxWidth: '75%' }}>
                <Paper
                  sx={{
                    p: 1.5,
                    borderRadius: msg.user_id == userId ? '18px 18px 0 18px' : '18px 18px 18px 0',
                    bgcolor: msg.user_id == userId ? '#dcf8c6' : 'white',
                  }}
                >
                  <Typography variant="body1">{msg.message}</Typography>
                </Paper>
                <Typography
                  variant="caption"
                  sx={{
                    alignSelf: msg.user_id == userId ? 'flex-end' : 'flex-start',
                    color: 'text.secondary',
                    mt: 0.5,
                  }}
                >
                  {formatTime(msg.created_at)}
                  {msg.user_id == userId && (
                    <span style={{ marginLeft: 4 }}>{msg.is_read ? '✓✓' : '✓'}</span>
                  )}
                </Typography>
              </Box>
            </ListItem>
          ))}
          <div ref={messagesEndRef} />
        </List>
      </Box>

      {/* Input Field */}
      <Box
        sx={{
          p: 2,
          bgcolor: '#f0f0f0',
          display: 'flex',
          alignItems: 'center',
          marginBottom: '22%',
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Type a message"
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          onKeyPress={(e) => e.key == 'Enter' && handleSend()}
          sx={{
            bgcolor: 'white',
            borderRadius: 20,
            '& .MuiOutlinedInput-root': {
              borderRadius: 20,
              paddingRight: 1,
            },
            border: '2px solid black',
          }}
          InputProps={{
            endAdornment: (
              <IconButton
                color="primary"
                onClick={handleSend}
                disabled={!newMessage.trim() || !receiverId}
              >
                <Send sx={{ color: 'black' }} />
              </IconButton>
            ),
          }}
        />
      </Box>

      {/* Bottom Navbar */}
      <Box sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}>
        <FormsBottomNavbar />
      </Box>
    </Box>
  );
};

export default ChatWindow;